import {
    useLocation,
} from 'react-router-dom'

import {
    useQuery,
} from '@tanstack/react-query'

import preCheckCandidateViewMutation from './services/pre-check-candidate-view'
import IdResultView from '../../Components/IdResultView'

const PreCheckCandidateView = () => {
    const location = useLocation()

    const queryParams = new URLSearchParams(location.search)
    const key = queryParams.get('key')

    const {
        data,
        error,
        isFetching,
    } = useQuery({
        queryKey: ['pre-check-candidate-view', key],
        queryFn: () => preCheckCandidateViewMutation({ key }),
        refetchOnWindowFocus: false,
    })

    return (
        <IdResultView
            data={data}
            referenceId={key}
            isFetching={isFetching}
            error={error}
        />
    )
}

export default PreCheckCandidateView
